import { Controller } from "@hotwired/stimulus"

// Admin membership form: keeps the "Customer pays" column in step with the monthly price,
// each term's pricing discount and any fixed price, so the admin sees what a customer would
// be charged before saving.
//
// The maths here mirrors MembershipTier#price — keep the two in step.
export default class extends Controller {
  static targets = ["monthlyPrice", "row"]

  connect() {
    this.recalculate()
  }

  recalculate() {
    const monthlyPrice = parseFloat(this.monthlyPriceTarget.value) || 0

    this.rowTargets.forEach((row) => {
      const months = parseInt(row.dataset.months, 10) || 1
      const discount = this.clampPercentage(parseFloat(row.querySelector("[data-discount]").value) || 0)
      const override = parseFloat(row.querySelector("[data-override]").value)

      const listPrice = this.round(monthlyPrice * months)
      const price = override > 0 ? this.round(override) : this.round((listPrice * (100 - discount)) / 100)
      const savings = Math.max(this.round(listPrice - price), 0)

      row.querySelector("[data-price]").textContent = this.rupees(price)

      // The struck-through list price only means something when the term actually saves money.
      const listPriceEl = row.querySelector("[data-list-price]")
      listPriceEl.textContent = this.rupees(listPrice)
      listPriceEl.classList.toggle("hidden", savings <= 0)

      row.querySelector("[data-monthly]").textContent = this.rupees(this.round(price / months))
    })
  }

  // -- helpers --

  clampPercentage(value) {
    return Math.min(Math.max(value, 0), 100)
  }

  // Matches how the page renders money server-side (number_with_precision, precision: 0):
  // whole rupees, no thousands separator, so nothing shifts around when the form is saved.
  rupees(value) {
    return `₹${Math.round(value)}`
  }

  round(value) {
    return Math.round(value * 100) / 100
  }
}
